import React from 'react';
import { Box, Container, Grid, Typography, Tabs, Tab } from '@mui/material';
import BudgetTemplateList from './BudgetTemplateList';
import BudgetRecurrenceList from './BudgetRecurrenceList';

/**
 * Page component for budget templates and recurrences
 */
const BudgetTemplatesPage = () => {
  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Budget Templates & Recurrences
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Create and manage budget templates and set up recurring budgets to automate your financial planning.
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            aria-label="budget templates tabs"
          >
            <Tab label="Templates" id="templates-tab" />
            <Tab label="Recurrences" id="recurrences-tab" />
          </Tabs>
        </Box>
        
        <Box>
          {tabValue === 0 && (
            <Box>
              <BudgetTemplateList />
            </Box>
          )}
          
          {tabValue === 1 && (
            <Box>
              <BudgetRecurrenceList />
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default BudgetTemplatesPage; 